export const GET_ALL_DEVICE_ALARM_MAPPINGS = "GET_ALL_DEVICE_ALARM_MAPPINGS";
